/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { type ComponentType } from 'react';
import { flagService } from '../../services/index.tsx';
import type { FlagService } from '../../services/types.tsx';

export type FlagServiceProps = {
	flagService: FlagService;
};

/**
 * The types for this aren't quite right - use with caution.
 * @deprecated Use `useFlagService` instead. HOCs are deprecated.
 */
const withFlagService =
	<TProps, TDefault extends DefaultProps>(
		WrappedComponent: ComponentType<FlagServiceProps & TProps> & TDefault,
	): DerivedFC<Omit<TProps, keyof FlagServiceProps>, TDefault> =>
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: any) => <WrappedComponent {...props} flagService={flagService} />;

export default withFlagService;

type InexactPartial<T> = { [K in keyof T]?: T[K] | undefined };

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export type DefaultProps = { defaultProps?: any };

/**
 * marks default-ed props as optional
 * without requirement for D to be "react component"
 */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type Defaultize<P, D> = P extends any
	? string extends keyof P
		? P
		: Pick<P, Exclude<keyof P, keyof D>> &
				InexactPartial<Pick<P, Extract<keyof P, keyof D>>> &
				InexactPartial<Pick<D, Exclude<keyof D, keyof P>>>
	: P;

export type DerivedFC<P, DF, Extra = {}> = React.FC<
	Defaultize<P, DF extends { defaultProps: infer R } ? R : {}> & Extra
> & { defaultProps?: undefined };
